import moment from 'moment';
import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useAppContext } from '../../appProvider/contextProvider';
import { upgradeShopifySubscription } from '../../services/shopifySubscription';
import { verifyInvoice } from '../../services/stripe';
import getAmount, { getFloatAmount } from '../../Util/getAmount';
import { viewPrivacyPolicy, viewTermsAndCondition } from '../../Util/TermsAndPrivacy';



const ConfirmPlan = () => {
    
    const { chosenPlan, 
        setChangePlanPopupOpen, 
        setIsVerifyPopupOpen, 
        setPricingPopupOpen , 
        isFetching,
        planDetails,
        isShopify,
        refetchProfile
    } = useAppContext();
   
    const [amountDue, setAmountDue] = useState(null);

    useQuery(['fetchInvoice', chosenPlan?.price_id], 
        () => verifyInvoice(chosenPlan?.price_id),
        {
            enabled: !!chosenPlan,
            onSuccess: ({amount_due}) => {
                if(amount_due){
                    setAmountDue(amount_due);
                }
            }
        }
    );

    const upgrade = useMutation(() => {
        return upgradeShopifySubscription(chosenPlan?.price_id);
    }, {
        onSuccess: async (data) => {
            if(data && data.confirmation_url) {
                refetchProfile();
                window.open(data.confirmation_url, '_self');
            }else {
                toast.error('Something went wrong');
            }
            setIsVerifyPopupOpen(false);
            // if(data.errors) {
            //     setUpdatePlanFailure(true);
            // } else {
            //     await refetchProfile();
            //     await refetchFeatures();
            //     await refetchWebsites();
            //     setUpdatePlanSuccess(true);
            // }
            // setChangePlanPopupOpen(false);
            
        }
    });

    const onConfirm = (event) => {
        event.preventDefault();
        if(isShopify) {
            upgrade.mutate();
        } else {
            setChangePlanPopupOpen(true);
            setIsVerifyPopupOpen(false);    
        }
    }

    const onBack = () => {
        setPricingPopupOpen(true);
        setIsVerifyPopupOpen(false);
    }

    const cancel = () => {
        setIsVerifyPopupOpen(false);
    }

    const nextPlanStartDate = () => {
        return moment(planDetails?.current_period_end).format('MMM DD, YYYY');
    }
    
    return  !isFetching && <> 
        <div className="modal fade show" tabindex="-1">
            <div className="modal-dialog ">
                <div className="modal-content">
                    <div className="modal-body p-5">
                        <h3 className="mb-4">Confirm your new pricing</h3>
                        <p className="text-uppercase my-3">Changing to { chosenPlan?.type === 'subscriber-based' ? 'Subscriber' : 'Impression'} Based Plan.</p>
                        <hr/>
                        <h5 className="mt-4"></h5>
                        {
                            isShopify ? <>
                                <div className="d-flex justify-content-between mb-4">
                                    <p className="mr-3">Number of { chosenPlan?.type === 'subscriber-based' ? 'Subscribers' : 'Impressions'} you will get</p>
                                    <p><b>{chosenPlan?.subscription_thresholds}</b></p>
                                </div>
                                <hr/>
                                <div className="d-flex justify-content-between mb-4">
                                    <p className="mr-3">Number of Website(s) you will get</p>
                                    <p><b>{chosenPlan?.website_thresholds}</b></p>
                                </div>
                                <hr/>
                            </>
                            :   <>
                                <div className="d-flex justify-content-between mb-4">
                                    <p className="mr-3">What you'll pay {chosenPlan?.recurring?.interval || chosenPlan?.interval}ly starting {nextPlanStartDate()}</p>
                                    <p>${getAmount(chosenPlan?.amount)}</p>
                                </div>
                                <hr/>
                                <div className="d-flex justify-content-between my-4">
                                    <p className="mr-3">Amount due today</p>
                                    <p><b>${getFloatAmount(amountDue)}</b></p>
                                </div>
                                <hr/>
                            </>
                        }
                        
                        {/* <ul className="list-unstyled my-4 pricing-details bg-grey p-3">
                            <li>
                                <span>Prorated credit from Subscriber based</span>
                                <span>-$34.80</span>
                            </li>
                            <li>
                                <span>Prorated credit from Subscriber based</span>
                                <span>-$34.80</span>
                            </li>
                            <li>
                                <span><b>Total</b></span>
                                <span><b>$234.80</b></span>
                            </li>
                        </ul> */}
                        {/* <div className="my-4">
                            <a href="" >Add promotion code</a>
                        </div> */}
                        <button className="btn btn-block btn-primary mt-5 mb-2"  onClick={onConfirm} >Confirm and Proceed</button>
                        <button className="btn btn-block btn-outline mb-3" onClick={onBack}>View other plans</button>
                        <button className="btn btn-block btn-danger mb-3" onClick={cancel}>Cancel</button>
                        <p><small>By confirming your new plan , you agree to Push Monkey ChirpyWeb's <b onClick={viewTermsAndCondition} className="terms-link">Terms of Service</b> and <b onClick={viewPrivacyPolicy} className="terms-link">Privacy Policy</b>.</small></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-backdrop fade show"></div>
    </>
}

export default ConfirmPlan;